import {
  formatDate,
  formatSentAtTimestamp,
  formatTime,
} from '#/shared/lib/format'

import type { PanelState } from './panel-state'

type ContractItem = PanelState['contract']['items'][number]

export interface ContractRow {
  id: string
  recipient: string
  sentAt: string
  signedAt: string | undefined
  status: 'signed' | 'not_signed'
  previewUrl: ContractItem['previewUrl']
  cca: boolean
  note: string | undefined
  signLink: string | undefined
}

function formatSignedAt(iso: string | undefined): string | undefined {
  if (!iso) return undefined
  const date = formatDate(iso)
  const time = formatTime(iso)
  return time ? `${date} ${time}` : date
}

export function toContractRow(item: ContractItem): ContractRow {
  return {
    id: item.id,
    recipient: item.recipient || '—',
    sentAt: formatSentAtTimestamp(item.sentAt),
    signedAt: formatSignedAt(item.signedAt),
    status: item.signed ? 'signed' : 'not_signed',
    previewUrl: item.previewUrl,
    cca: item.cca,
    note: item.note,
    signLink: item.signLink,
  }
}

export function openContractPreview(contract: { previewUrl?: string }) {
  if (contract.previewUrl) {
    window.open(contract.previewUrl, '_blank', 'noopener,noreferrer')
  }
}
